/**
 * ThreeDotsMenuIcon Component
 * Three vertical dots inside a circular background for row actions menu.
 */

import React from "react";
import type { IconProps } from "./types";
import { colors } from "../colors";

interface ThreeDotsMenuIconProps extends IconProps {
  /** Background circle color */
  bgColor?: string;
}

const ThreeDotsMenuIcon: React.FC<ThreeDotsMenuIconProps> = ({
  size = 30,
  color = colors.neutral.white,
  bgColor = colors.background[600],
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={30} height={30} rx={15} fill={bgColor} />
    <path
      d="M10 13.333c-.917 0-1.667.75-1.667 1.667s.75 1.667 1.667 1.667 1.667-.75 1.667-1.667-.75-1.667-1.667-1.667zm10 0c-.917 0-1.667.75-1.667 1.667s.75 1.667 1.667 1.667 1.667-.75 1.667-1.667-.75-1.667-1.667-1.667zm-5 0c-.917 0-1.667.75-1.667 1.667s.75 1.667 1.667 1.667 1.667-.75 1.667-1.667-.75-1.667-1.667-1.667z"
      fill={color}
    />
  </svg>
);

export default ThreeDotsMenuIcon;
